import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	copyAction: {
		id: 'directories.filters-v2.main.content.cells.actions.copy-action',
		defaultMessage: 'Copy filter',
		description:
			'Label displayed in the filters directory, when we click on meatball menu of the filters list item. To enable copying of an existing filter',
	},
	editFilter: {
		id: 'directories.filters-v2.main.content.cells.actions.edit-filter',
		defaultMessage: 'Edit',
		description:
			'Label displayed in the filters directory, when we click on meatball menu of the filters list item. To enable editing of an existing filter',
	},
	changeOwner: {
		id: 'directories.filters-v2.main.content.cells.actions.change-owner',
		defaultMessage: 'Change owner',
		description:
			'Label displayed in the filters directory, when we click on meatball menu of the filters list item. To enable changing owner of an existing filter which they own',
	},
	deleteFilter: {
		id: 'directories.filters-v2.main.content.cells.actions.delete-filter',
		defaultMessage: 'Delete',
		description:
			'Label displayed in the filters directory, when we click on meatball menu of the filters list item. To enable deleting of an existing filter',
	},
	manageAction: {
		id: 'directories.filters-v2.main.content.cells.actions.manage-action',
		defaultMessage: 'Manage subscriptions',
		description:
			'Label displayed in the filters directory, when we click on meatball menu of the filters list item. To enable subscription settings of an existing filter',
	},
});
